/** Route patterns (for Route components) */
export const projectPaths = {
  BASE: '/projects/:projectId',
  PROPOSAL: '/projects/:projectId/proposals/:proposalId'
} as const;

// Base Path Builders - Single source of truth for project/proposal base URLs
export const buildProjectPath = (projectId: string): string => `/projects/${projectId}`;

export const buildProposalPath = (projectId: string, proposalId: string): string =>
  `${buildProjectPath(projectId)}/proposals/${proposalId}`;
